import React from 'react'
import { Helmet } from 'react-helmet'
import preconsentIcon from '../../asset/large-preconsent-icon.svg'
import { LoadingPageContainer } from '../../components/PageWrapper/styles'
import LoadingPageCard from '../../components/LoadingPageCard'

const GenerateLoading = () => {
  const LoadingPageData = {
    centerIcon: preconsentIcon,
    subtitle: 'Generating your tailored products from the data you have shared',
  }
  return (
    <LoadingPageContainer>
      <Helmet>
        <title>Loading</title>
        <link rel="icon" href="./asset/projectIcon.svg" />
      </Helmet>
      <LoadingPageCard {...LoadingPageData} />
    </LoadingPageContainer>
  )
}

export default GenerateLoading
